import Vue from 'vue';

export default new Vue({
  methods: {
    updatePermissions(user) {
      const permissions = user.data.role.permissionsList;
      this.$emit('update-permissions', permissions);
      user.permissionsList = permissions;
      return user;
    },
  },
});
